<template>
    <div>
        <router-view :url="url" v-on:updateTitle="updateTitle"></router-view>
    </div>
</template>

<script>
export default {
  name: 'Shipment',
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/shipments'
    }
  },
  created: function () {
    this.$emit('activeMenu', '/admin/shipments')
    this.$emit('newLink', '/admin/shipments/create')
    this.$emit('updateDisable', false)
  },
  methods: {
    updateTitle (val) {
      this.$emit('updateTitle', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/shipment/Shipment.vue